import AddIcon from '@mui/icons-material/Add';
import { Grid, styled } from '@mui/material';

export const StyledMenuResourceItem = styled(Grid)`
    align-items: center;
    padding-bottom: 10px;
    padding-top: 10px;
    padding-left: 12px;
    margin-bottom: 5px;
    min-height: 55px;
    cursor: pointer;
    box-sizing: content-box;

    font-family: Roboto;
    font-size: 24px;
    font-weight: 400;
    letter-spacing: 0;
    color: white;
    width: 98%;

    &.selected {
        background: #006ebb;
    }

    &.unavailable {
        color: #ffffff;
        opacity: 0.3;
    }
`;

export const StyledAddIcon = styled(AddIcon)`
    height: 36px;
    width: 36px;
`;

export const StyledPropertiesBox = styled(Grid)`
    text-align: center;
    display: flex;
    justify-content: flex-start;
    padding-left: 10px;
`;
